import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagUmbrella = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={17} height={18} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M.962 3.182a8.934 8.934 0 0 1 12.635 12.634l-.08-.834a3.738 3.738 0 0 0-4.135-3.377 4.209 4.209 0 0 0-4.209-4.209A3.737 3.737 0 0 0 1.8 3.258l-.838-.076z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.153 8.63l-6.348 6.344a1.191 1.191 0 1 0 1.684 1.685M13.597 3.182l.842-.843"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagUmbrella;
